<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-12">
        <div class="row">
          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [required]="true" [onlyConfigured]="true"></app-company-selector>
          </div>
          <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear" [required]="true">
            </app-year-selector>
          </div>
          <div class="col-md col-lg col-xl">
            <mat-form-field>
              <mat-select data-size="7" [(ngModel)]="sustitucionesCerradas" name="cerradas"
                placeholder="Mostrar sustituciones cerradas">
                <mat-option [value]="true">Sí</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany"
              (click)="onSearch()">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <dx-data-grid id="gridContainer" [dataSource]="dataSource"  [columnChooser]="false"  [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)" (onEditorPreparing)="onEditorPreparing($event)">

      <dxo-export [enabled]="true"></dxo-export>

      <!-- Definición de las columnas -->
      <dxi-column caption="Trabajador" alignment="center">
        <dxi-column dataField="EmpleadoEnIt.A3LEmployeeCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="EmpleadoEnIt.A3LCompleteName" caption="Trabajador"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Centro" alignment="center">
        <dxi-column dataField="EmpleadoEnIt.A3LWorkplaceCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="EmpleadoEnIt.A3LWorkplaceName" caption="Centro"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Imputación" alignment="center">
        <dxi-column dataField="EmpleadoEnIt.A3LCostAttributionNodeCode" caption="Código" alignment="center"> </dxi-column>
        <dxi-column dataField="EmpleadoEnIt.A3LCostAttributionNodeDescription" caption="Imputación"> </dxi-column>
      </dxi-column>

      <dxi-column caption="Datos de la sustitución" alignment="center">
        <dxi-column dataField="FechaInicioIt" caption="Inicio"  dataType="date" alignment="left" format="dd/MM/yyyy"> </dxi-column>
        <dxi-column dataField="FechaFinIt" caption="Fin" dataType="date" alignment="left" format="dd/MM/yyyy"> </dxi-column>
        <dxi-column dataField="A3LItDescription" caption="Tipo"> </dxi-column>
      </dxi-column>
      <dxi-column caption="Sustitución" alignment="center">
        <dxi-column dataField="EmpleadoSustituto.A3LCompleteName" caption="Sustituto" [calculateDisplayValue]="getSustitutoCalculateDisplayValue"> </dxi-column>
        <dxi-column dataField="FechaInicio" caption="Inicio" dataType="date" alignment="left" format="dd/MM/yyyy"> </dxi-column>
      </dxi-column>


      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column dataField="Id"  [allowExporting]="false" caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEdit(data.value)">
            <i class="material-icons">edit</i>
          </button>
          <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onClickDelete(data.value, data.rowIndex)">
            <i class="material-icons">close</i>
          </button>
        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->
      <div *dxTemplate="let data of 'addNew'">
        <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd()">
          <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Nuevo</span></button>
      </div>

    </dx-data-grid>

    <!-- <div class="row" style="margin-top: 20px;">
      <div class="col">
        <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany">Quitar complementos de IT</button>
      </div>
    </div> -->
  </app-generic-panel>
  <br>
</app-generic-container>
